const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const {TransitionGroup, CSSTransition} = require("react-transition-group");
const _ = require("lodash");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const Link = require("../../core/view/Link");
const ComputerScreenshot = require("../../core/view/ComputerScreenshot");

const OfficeModal = require("../modals/OfficeModal");
const modalStyles = require("../modals/styles/OfficeModalsGeneral.css");
const ApparelSection = require("../ApparelSection");
const BookstoreUtil = require("../../../shared/BookstoreUtil");
const ApparelUtil = require("../../core/util/ApparelUtil");
const AssetsUtil = require("../../core/util/AssetsUtil");
const AT = require("../../core/vault/ActionTypes");
const OpsCart = require("../vault/OpsCart");
const URLMake = require("../../../shared/URLMake");
const {track} = require("../../core/util/Mixpanel");
const styles = require("./styles/Suggestions.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "Suggestions",

		propTypes: {
			cart: PT.object.isRequired,
			className: PT.string,
			inModal: PT.bool,
			tabIndexStart: PT.number,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		getInitialState: function() {
			return {showApparelModal: false};
		},

		UNSAFE_componentWillMount: function() {
			this.items = this.props.cart.items;
			this.makeSmallRows = this.items.length > 8 || this.props.inModal;
			this.suggestions = OpsCart.getSuggestions(this.props.cart);
			this.addButtons = [];
		},

		UNSAFE_componentWillUpdate: function() {
			this.addButtons = [];
		},

		addToCart: function(sku, options = {}) {
			this.props.dispatch({
				type: AT.ADD_ITEM_TO_CART,
				sku,
				quantity: 1,
				skipModal: true,
				options,
				fromSuggestions: true,
			});
		},

		blurAddButtons: function() {
			_.each(this.addButtons, button => {
				button.blur();
			});
		},

		toggleModal: function(show) {
			this.setState({showApparelModal: show});
		},

		dismissModal: function() {
			track("Apparel Suggestion Dismissed", {sku: "shirt-beast"});
			this.setState({showApparelModal: false});
		},

		renderSuggestion: function(sku, i) {
			const isSubscription = sku === "ba-online";
			const isApparelSku = _.includes(ApparelUtil.getAllApparelSkus(), sku);
			let productLabel = null;
			let buttonText = "Add";
			let info;
			let nameText;
			let productImageClass;
			let linkTo;
			let productImageSrc;
			if (isSubscription) {
				nameText = "BA Online";
				productImageClass = styles.onlineLaptop;
				linkTo = URLMake.forEnroll();
				buttonText = "Enroll";
			} else if (isApparelSku) {
				info = ApparelUtil.getApparelInfoFromSku(sku);
				// Set to a shortened version of the name for our youth small shirt to prevent line wrapping.
				// This is currently the only apparel item that can ever appear as a suggestion.
				// If that changes, we'll need to do something more flexible here when shortening the name.
				nameText = "T-Shirt";
				buttonText = "Select Size";
				productImageClass = styles.apparel;
				productImageSrc = ApparelUtil.getApparelImageSrc(
					info.apparelHash,
					true,
					"small"
				);
			} else {
				info = BookstoreUtil.getBookInfoFromSKU(sku);
				const isPuzzleBook = BookstoreUtil.isPuzzleBook(info.bookHash);
				const isScienceBook = BookstoreUtil.isScienceBook(info.bookHash);
				if (isPuzzleBook) {
					nameText = `Puzzles ${BookstoreUtil.getGradeFromHash(info.bookHash)}`;
				} else if (info.type === "science") {
					nameText = `${info.bookHash.substring(0, 2)} Science`;
				} else if (!_.includes(["practice", "guide"], info.type)) {
					nameText = info.bookHash;
				} else {
					nameText = info.bookHash + " " + _.capitalize(info.type);
				}

				productImageClass = styles.book;
				linkTo = isScienceBook
					? URLMake.forScienceBook(info.bookHash)
					: URLMake.forBook(info.bookHash);
				const gradeNumber = BookstoreUtil.getGradeFromHash(info.bookHash);
				const labelClass = styles["label" + gradeNumber];
				const labelContent = isPuzzleBook ? (
					<img
						className={styles.puzzleImage}
						src={AssetsUtil.getPuzzlePiece("white")}
					/>
				) : (
					info.bookHash
				);
				productLabel = <div className={labelClass}>{labelContent}</div>;
				productImageSrc = BookstoreUtil.getBookCoverSrc(
					info.bookHash,
					info.type === "practice",
					"small"
				);
			}
			const onAdd = () => {
				if (isSubscription) {
					track("Subscription Suggestion Clicked");
				} else if (isApparelSku) {
					track("Apparel Suggestion Clicked", {sku});
					this.toggleModal(true);
				} else {
					track("Suggestion Added to Cart", {sku});
					this.addToCart(sku);
				}
			};
			const onKeyPress = evt => {
				if (evt.which === 13) {
					onAdd();
				}
			};

			let suggestionClass = i > 1 ? styles.suggestionB : styles.suggestionA;

			const contentClass = this.props.inModal
				? styles.modalSContents
				: styles.sContents;
			const imageClass = this.props.inModal ? styles.modalImage : styles.image;
			let addDiv;
			let suggestionKey = sku;

			if (
				_.findIndex(this.items, item => item.sku === sku) === -1 ||
				isApparelSku
			) {
				const onAddClick = isSubscription ? null : onAdd;
				const onAddKeyPress = isSubscription ? null : onKeyPress;
				const addButtonClass = styles.add + " " + styles.addButton;

				addDiv = (
					<div
						className={isSubscription ? null : addButtonClass}
						ref={v => {
							if (v) {
								this.addButtons.push(v);
							}
						}}
						onClick={onAddClick}
						onKeyPress={onAddKeyPress}
						onContextMenu={this.blurAddButtons}
						tabIndex={this.props.tabIndexStart + i}
					>
						{buttonText}
					</div>
				);
				addDiv = isSubscription ? (
					<Link to={linkTo} className={addButtonClass} clickAction={onAdd}>
						{addDiv}
					</Link>
				) : (
					addDiv
				);
			} else {
				suggestionClass += " " + styles.inCart;
				suggestionKey = "in-cart-" + sku;
				addDiv = (
					<div className={styles.add + " " + styles.addedText}>In Cart</div>
				);
			}

			const image = isSubscription ? (
				<ComputerScreenshot
					screenshotType={"home-page-tiny"}
					alt={"Beast Academy online"}
					computerType={"laptop-black"}
					className={productImageClass}
				/>
			) : (
				<img
					className={productImageClass}
					alt={nameText}
					src={productImageSrc}
				/>
			);

			const productTitle = `${nameText}:`;

			const product = linkTo ? (
				<Link to={linkTo} className={styles.link}>
					<div className={imageClass}>
						{image}
						{productLabel}
					</div>
				</Link>
			) : (
				<div onClick={onAdd} className={styles.apparelProduct}>
					<div className={imageClass}>
						{image}
						{productLabel}
					</div>
				</div>
			);

			return (
				<CSSTransition
					classNames={{
						enter: styles.suggestionEnter,
						enterActive: styles.suggestionEnterActive,
						exit: styles.suggestionExit,
						exitActive: styles.suggestionExitActive,
					}}
					timeout={{enter: 700, exit: 700}}
					key={suggestionKey}
				>
					<div className={suggestionClass}>
						<div className={contentClass}>
							<div className={styles.productTitle}>{productTitle}</div>
							{product}
							{addDiv}
						</div>
					</div>
				</CSSTransition>
			);
		},

		render: function() {
			this.items = this.props.cart.items;
			const suggestionList = this.suggestions.map(this.renderSuggestion);

			let mainClass = styles.main;
			if (this.props.className) {
				mainClass += " " + this.props.className;
			}
			if (!suggestionList.length) {
				mainClass += " " + styles.noSuggestions;
			}

			const titleClass = this.props.inModal ? styles.modalTitle : styles.title;
			const suggestionsClass = this.props.inModal
				? styles.modalSuggestions
				: styles.suggestions;
			const titleText = OpsCart.isEmpty(this.props.cart)
				? "Products to Consider"
				: "More to Consider";

			let apparelModal;
			if (this.state.showApparelModal) {
				apparelModal = (
					<OfficeModal
						onClose={() => this.dismissModal()}
						level={"overBar"}
						portalContainer={null}
						closeOnBackdropClick={true}
						modalClass={styles.apparelModal}
						closeClass={modalStyles.closeButtonSmall}
					>
						<ApparelSection
							apparelHash={"shirt-beast"}
							addApparel={() => this.toggleModal(false)}
						/>
					</OfficeModal>
				);
			}

			return (
				<div className={mainClass}>
					<div className={titleClass}>{titleText}</div>
					<TransitionGroup component="div" className={suggestionsClass}>
						{suggestionList}
					</TransitionGroup>
					{apparelModal}
				</div>
			);
		},
	})
);
